'use strict';

exports.__esModule = true;
exports.TAG_SCHEMAS = undefined;

var _props, _props2, _TAG_SCHEMAS;

var _Props = require('./Props');

var _Props2 = _interopRequireDefault(_Props);

var _TagTypes = require('./TagTypes');

var _Identifiers = require('./Identifiers');

var _Validators = require('./Validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAG_SCHEMAS = exports.TAG_SCHEMAS = (_TAG_SCHEMAS = {}, _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TITLE] = {
  type: _TagTypes.TAG_TYPES.TITLE,
  children: true,
  getValue: function getValue(tag) {
    return tag.children;
  },
  setValue: function setValue(tag, value) {
    tag.children = value;
    return { isValid: true };
  }
}, _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.DESCRIPTION] = buildStandardMeta('description'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_TITLE] = buildOgMeta('og:title'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_DESCRIPTION] = buildOgMeta('og:description'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_IMAGE] = buildOgMeta('og:image'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_IMAGE_WIDTH] = buildOgMeta('og:image:width'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_IMAGE_HEIGHT] = buildOgMeta('og:image:height'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_URL] = buildOgMeta('og:url'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_SITE_NAME] = buildOgMeta('og:site_name'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.FB_ADMINS] = buildStandardMeta('fb:admins'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.OG_TYPE] = buildOgMeta('og:type'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_TITLE] = buildStandardMeta('twitter:title'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_DESCRIPTION] = buildStandardMeta('twitter:description'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_URL] = buildStandardMeta('twitter:url'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_IMAGE] = buildStandardMeta('twitter:image'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_CARD] = buildStandardMeta('twitter:card'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.TWITTER_SITE] = buildStandardMeta('twitter:site'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.ROBOTS] = buildStandardMeta('robots'), _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.STRUCTURED_DATA] = {
  type: _TagTypes.TAG_TYPES.SCRIPT,
  props: (_props = {}, _props[_Props2.default.TYPE] = 'application/ld+json', _props),
  children: true,
  getValue: function getValue(tag) {
    return tag.children;
  },
  setValue: function setValue(tag, value) {
    var validator = (0, _Validators.validateJson)(value);
    if (validator.isValid) {
      tag.children = value;
    }
    return validator;
  }
}, _TAG_SCHEMAS[_Identifiers.IDENTIFIERS.CANONICAL] = {
  type: _TagTypes.TAG_TYPES.LINK,
  props: (_props2 = {}, _props2[_Props2.default.REL] = 'canonical', _props2[_Props2.default.HREF] = '', _props2),
  getValue: function getValue(tag) {
    return tag.props[_Props2.default.HREF];
  },
  setValue: function setValue(tag, value) {
    var validator = (0, _Validators.validateFullUrl)(value);
    if (validator.isValid) {
      tag.props[_Props2.default.HREF] = value;
    }
    return validator;
  }
}, _TAG_SCHEMAS);

function buildOgMeta(name) {
  return buildStandardMeta(name, _Props2.default.PROPERTY);
}

function buildStandardMeta(name) {
  var _props3;

  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Props2.default.NAME;

  return {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props3 = {}, _props3[prop] = name, _props3[_Props2.default.CONTENT] = '', _props3),
    getValue: function getValue(tag) {
      return tag.props[_Props2.default.CONTENT];
    },
    setValue: function setValue(tag, value) {
      tag.props[_Props2.default.CONTENT] = value;
      return { isValid: true };
    }
  };
}